<template>
  <section class="product" :class="{ isLoad }">
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <div class="container">
      <div v-if="isLoad" class="product__wrapper">
        <ProductCard
          :product="product"
          @prevSlide="prevSlide"
          @nextSlide="nextSlide"
          @playVideo="showVideo"
          :showVideo="Boolean(product.video)"
        ></ProductCard>
        <teleport to="body">
          <Video
            @close="videoClose"
            :titleVisible="false"
            :code="product.video"
            v-if="isShowVideo"
          />
        </teleport>

        <ProductCatalog
          v-if="product.set.length > 0"
          :title="recommendedTitle"
          :items="product.set"
          :count="0"
          :page="1"
          :show-filters="false"
        />

        <Social />
        <!--<Contacts />-->
      </div>
      <Spinner v-else />
    </div>
  </section>
</template>

<script setup>
import Video from "~/components/Modals/Video.vue";
import ProductCard from "./ProductCard.vue";
import StepBtn from "~/components/UI/btn/stepSlideBtn.vue";
import Social from "~/components/Section/Social.vue";
import Contacts from "~/components/Section/Contacts.vue";
import Spinner from "~/components/animate/SpinnerComponent.vue";
import { Product } from "~/api/Product";
import Breadcrumbs from "~/components/Section/Breadcrumbs.vue";
import ProductCatalog from "~/components/Section/Product-Catalog.vue";

const title = ref("");
const metaDescription = ref("");
const metaKeywords = ref("");
const metaImage = ref("");
const breadcrumbs = ref([
  {
    title: "Главная",
    url: "/",
  },
  {
    title: "Каталог",
    url: "/catalog",
  },
]);

const pageUrl = useRequestURL().href;

useHead({
  title,
  meta: [
    { name: 'description', content: metaDescription },
    { name: 'keywords', content: metaKeywords },
    { property: 'og:type', content: 'website' },
    { property: 'og:site_name', content: 'Шарунстор' },
    { property: 'og:title', content: title },
    { property: 'og:description', content: metaDescription },
    { property: 'og:image', content: metaImage },
    { property: 'og:url', content: pageUrl },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: metaDescription },
    { name: 'twitter:image', content: metaImage },
  ],
});

const props = defineProps({
  productId: {
    type: Number,
    required: true,
  },
});
let isLoad = ref(false);
let index = ref(0);
let maxItems = ref(3);

let product;
try {
  product = await Product.getInfo(useRoute().params.id);
  product.tree.forEach((el) =>
    breadcrumbs.value.push({
      title: el.name,
      url: `/catalog/${el.id}`,
    }),
  );
  breadcrumbs.value.push({
    title: product.name,
  });
} catch (e) {
  navigateTo("/");
}

const recommendedTitle = computed(() =>
  product.isSet ? "Одежда для образа" : "Рекомендуем",
);
const isShowVideo = ref(false);

const showVideo = () => {
  isShowVideo.value = true;
};

const videoClose = () => {
  isShowVideo.value = false;
};

title.value = `SHARUN.STORE - ${product.name}`;
metaDescription.value = product.metaDescription;
metaKeywords.value = product.metaKeywords;
metaImage.value = product.mainImage?.path ?? '';
isLoad.value = true;

const nextSlide = () => {
  index.value < maxItems.value - 1 ? index.value++ : (index.value = 0);
};
const prevSlide = () => {
  index.value > 0 ? index.value-- : (index.value = maxItems.value - 1);
};
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>
